interface TimelineProps {
    event: {
        icon: string;
        date: string;
        title: string;
        desc: string;
    },
    index: string | number;
}
function Timeline(props: TimelineProps) {
    const { event, index } = props;
    return (<div>
        <div key={index} className="mb-10 ml-6 w-full">
            <div className="absolute -left-[21px] flex items-center justify-center w-10 h-10 bg-secondary rounded-full text-white">
                <i className={`fa-solid ${event.icon}`}></i>
            </div>
            <div className="p-4 bg-time rounded-2xl w-full">
                <p className="text-sm text-gray-500">{event.date}</p>
                <h3 className="text-bold font-semibold mt-1">{event.title}</h3>
                <p className="text-gray-700 text-sm mt-1">{event.desc}</p>
            </div>
        </div>
    </div>);
}

export default Timeline;